import api from './api';

export interface BrandTemplate {
  id: string;
  name: string;
  description?: string;
  template_data: {
    brand_voice?: string;
    website?: string;
    brand_colors?: {
      primary: string;
      secondary: string;
      accent: string;
      neutral: string;
    };
    target_audience?: string;
    industry?: string;
    primary_goal?: string;
    brand_personality?: string[];
  };
  created_at: string;
  updated_at: string;
}

export interface BrandTemplateCreate {
  name: string;
  description?: string;
  template_data: any;
}

class BrandTemplateService {
  async getTemplates(clientId: string): Promise<BrandTemplate[]> {
    const response = await api.get(`/brand-templates/?client_id=${clientId}`);
    return response.data;
  }

  async createTemplate(clientId: string, templateData: BrandTemplateCreate): Promise<BrandTemplate> {
    const response = await api.post(`/brand-templates/?client_id=${clientId}`, templateData);
    return response.data;
  }

  async deleteTemplate(clientId: string, templateId: string): Promise<void> {
    await api.delete(`/brand-templates/${templateId}?client_id=${clientId}`);
  }
}

export default new BrandTemplateService();